<template>
  <div>
    <DesktopLayout
      v-if="!isMobile && ((windowSize.width > 1280 && windowSize.height > 800) || (windowSize.width > 800 && windowSize.height > 1280))"
    />
    <MobileLayout v-else />
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';

import DesktopLayout from '@/layout/DesktopLayout.vue';
import MobileLayout from '@/layout/MobileLayout.vue';
import useCommonStore from '@/store/storeCommon';


const { isMobile } = storeToRefs(useCommonStore());
const { windowSize } = useCommonStore();

onMounted(() => {
  window.addEventListener('resize', () => {
    onWindowResize();
  });
  const accessInfo = navigator.userAgent;
  if (
    accessInfo.indexOf('iPhone') > -1 ||
    accessInfo.indexOf('Android') > -1 ||
    accessInfo.indexOf('iPad') > -1 ||
    accessInfo.indexOf('iPod') > -1 ||
    (accessInfo.includes('Mac OS') && navigator.maxTouchPoints > 1)
  ) {
    isMobile.value = true;
  } else {
    isMobile.value = false;
  }
});

/**
 * 윈도우 가로, 세로 사이즈를 감지합니다.
 */
const onWindowResize = (): void => {
  windowSize.width = window.innerWidth;
  windowSize.height = window.innerHeight;
};
</script>

<style lang="scss">
#app {
  font-family: xeicon, sans-serif;
  width: 100vw;
  height: 100dvh;
}
</style>